import {
  getManufacturingV1Data,
  patchManufacturingV1Data,
  putManufacturingV1Data,
} from 'services/manufacturingV1';

export const createProductionEvent = async ({
  data,
  productionOrderId,
  orgRef,
}) => {
  let response = '';
  let errorMessage = '';
  
  try {
    response = await putManufacturingV1Data({
      url: `/organisations/${orgRef}/productionevents/${productionOrderId}`,
      data,
      withAuth: true,
    })
  } catch (error) {
    errorMessage = error.message;
  }
  return { response, errorMessage };
}


export async function getProductionEvents({ orgRef, reqParams = {} }) {
  let response = '';
  let errorMessage = '';
  try {
    response = await getManufacturingV1Data({
      apiConfig: {
        params: reqParams,
      },
      url: '/dispatchersalesorders',
      withAuth: true,
    })
  } catch (error) {
    errorMessage = error.message;
  }
  return { response, errorMessage };
}

export async function patchProductionEvents({ events, dispatcherOrderId }) {
  await patchManufacturingV1Data({
    url: `/dispatchersalesorders/${dispatcherOrderId}`,
    data: events,
    withAuth: true,
  });
}
